// extracted by mini-css-extract-plugin
module.exports = {"flexCenter":"styles_flexCenter__283Ge","title":"styles_title__1wJ2u","padding24":"styles_padding24__3ahDz"};